export enum CreateTempFileOriginType {
  E_MAIL_ATTACHEMENT = 'E_MAIL_ATTACHEMENT',
  DOCUMENT = 'DOCUMENT',
  LETTER = 'LETTER',
  ERP_ATTACHMENT = 'ERP_ATTACHMENT',
}
